import { MouseEvent, ReactElement } from 'react';
import { ROUTES } from '@client/routes/components/Router/routes';
import { useRouterPush, useUrlCreator } from '@client/routes/hooks';
import { Features } from './Features';
import { Props } from './FeaturesContainer.types';

export const FeaturesContainer = (props: Props): ReactElement => {
  const {
    manufacturerInternalPage,
    ...originalProps
  } = props;
  const pushAction = useRouterPush();
  const urlCreator = useUrlCreator();
  const manufacturerPageUrl = `${urlCreator(
    ROUTES.manufacturer,
    { manufacturer: manufacturerInternalPage.replace('/', '') },
  )}`;

  const handleManufacturerPageClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    pushAction(manufacturerPageUrl);
  };

  return (
    <Features
      {...originalProps}
      onManufacturerPageClick={handleManufacturerPageClick}
      manufacturerPageUrl={manufacturerPageUrl}
    />
  );
};
